import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { ModelResponse } from "@/types";

async function fetchModels(
  page?: string | null,
  per_page?: number | null,
  search?: string | null,
  entity_type?: string | null
): Promise<ModelResponse> {
  const pageParams = !per_page
    ? `page=${page || 1}`
    : `page=${page || 1}&per_page=${per_page}&search=${encodeURIComponent(search ?? "")}`;
  
  const entityParams = entity_type ? `&entity_type=${entity_type}` : "";
  
  const models = await httpRequest.get<ModelResponse>(`/models?${pageParams}${entityParams}`);
  return models.data;
}

export function useFetchModelsQuery({
  page,
  per_page,
  search,
  entity_type,
  enabled,
}: {
  enabled?: boolean;
  page?: string | null;
  per_page?: number | null;
  search?: string | null;
  entity_type?: string | null;
}) {
  const modelsQuery = useQuery({
    enabled,
    queryKey: ["models", page || "1", per_page, search, entity_type],
    queryFn: () => fetchModels(page, per_page, search, entity_type),
    keepPreviousData: true,
  });

  return {
    ...modelsQuery,
    data: modelsQuery?.data,
  };
}

async function fetchModelsNoPagination(entity_type?: string | null): Promise<ModelResponse> {
  const entityParams = entity_type ? `?entity_type=${entity_type}` : "";
  const models = await httpRequest.get<ModelResponse>(`/models${entityParams}`);
  return models.data;
}

export function useFetchModelsNoPaginationQuery(entity_type?: string | null) {
  const modelsQuery = useQuery({
    queryKey: ["models", entity_type],
    queryFn: () => fetchModelsNoPagination(entity_type),
    keepPreviousData: true,
  });

  return {
    ...modelsQuery,
    data: modelsQuery?.data,
  };
}

export function useFetchModelsForContractQuery(entity_type: string, search?: string) {
  const modelsQuery = useQuery({
    queryKey: ["models", entity_type, search],
    queryFn: () => fetchModels("1", 100, search || null, entity_type),
    keepPreviousData: true,
  });

  return {
    ...modelsQuery,
    data: modelsQuery?.data,
  };
}
